import React from "react";
import styled from "styled-components";
import Logo from "../../SVGs/FooterLogo.svg";

function Footer() {
  return (
    <Container>
      <Top>
        <Image src={Logo} />
        <Flex>
          <Text>866-447-2380</Text>
          <Text>
            30700 Russell Ranch Rd #250
            <br />
            Westlake Village, CA 91362
          </Text>
        </Flex>
      </Top>
      <Bottom>
        <Terms>© 2026 Hippocratic Financial Advisors, LLC</Terms>
      </Bottom>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  aling-items: center;
  flex-direction: column;
  background-color: var(--darkBlue);
  padding: 50px 5vw 20px 5vw;
  gap: 40px;
  margin-top: 5vh;
`;

const Image = styled.img``;

const Top = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: space-between;

  @media screen and (max-width: 596px) {
    flex-direction: column;
    gap: 60px;
    justify-content: space-between;
  }
`;

const Bottom = styled.div``;

const Flex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const Text = styled.div`
  color: #fff;
  font-family: "Museo Sans Cyrl";
  font-size: 19.2px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  white-space: nowrap;
`;

const Terms = styled.div`
  color: #fff;
  font-family: "Museo Sans Cyrl";
  font-size: 14.4px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  opacity: 0.4;
`;
export default Footer;
